  <template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Proposal Plan</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Proposal Plan</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Proposal Plan</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.propType }}</v-subheader>
                <div class="queryValue">{{ form.propType }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.propType"
                  :items="propTypeList"
                  v-model="form.propType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="propType"
                  :data-vv-as="labels.propType"
                  :error-messages="errors.collect('propType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
                <div class="queryValue">{{ form.polType }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.polType"
                  :label="labels.polType"
                  :error-messages="errors.collect('polType')"
                  data-vv-name="polType"
                  :data-vv-as="labels.polType"
                  v-validate="'required'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('polType')"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.srchBy }}</v-subheader>
                <div class="queryValue">{{ form.srchBy }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.srchBy"
                  :items="srchByList"
                  v-model="form.srchBy"
                  item-text="value"
                  item-value="code"
                  data-vv-name="srchBy"
                  :data-vv-as="labels.srchBy"
                  :error-messages="errors.collect('srchBy')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.scheme }}</v-subheader>
                <div class="queryValue">{{ form.scheme }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.scheme"
                  :label="labels.scheme"
                  :error-messages="errors.collect('scheme')"
                  data-vv-name="scheme"
                  :data-vv-as="labels.scheme"
                  v-validate="'required'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('scheme')"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.planNo }}</v-subheader>
                <div class="queryValue">{{ form.planNo }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.planNo"
                  :items="polNoList"
                  v-model="form.planNo"
                  item-text="value"
                  item-value="code"
                  data-vv-name="planNo"
                  :data-vv-as="labels.planNo"
                  :error-messages="errors.collect('planNo')"
                  :disabled="isSrchByS"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.planDesc }}</v-subheader>
                <div class="queryValue">{{ form.planDesc }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.planDesc"
                  :label="labels.planDesc"
                  :error-messages="errors.collect('planDesc')"
                  data-vv-name="planDesc"
                  :data-vv-as="labels.planDesc"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn :disabled="queryMode" color="primary" dark @click="doSave" :loading="submitting">
              {{ newMode ? 'Save' : '' }}{{ reviewMode ? 'Update' : '' }}
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- helplist -->
      <v-dialog v-model="helplist" width="900px" persistent>
        <polType-help-list v-if="polTypeHelpList" @close="doClose" @selectPolType="doAssignPolType($event)"></polType-help-list>
        <scheme-help-list v-if="schemeHelpList" @close="doClose" @selectScheme="doAssignScheme($event)"></scheme-help-list>
        <busCls-help-list v-if="busClsHelpList" @close="doClose" @selectBusCls="doAssignBusCls($event)"></busCls-help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { propType, srchBy } from '@/const/underwriting'
import PolTypeHelpList from './helplist/PolTypeHelplist'
import SchemeHelpList from './helplist/SchemeHelplist'
import BusClsHelpList from './helplist/BusClsHelplist'
export default {
  data() {
    return {
      labels: {
        propType: 'Proposal Type',
        polType: 'Policy Type',
        srchBy: 'Search By',
        scheme: 'Scheme/Class',
        planNo: 'Plan No.',
        planDesc: 'Plan Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        propType: 'FI',
        polType: null,
        scheme: null,
        planNo: null,
        srchBy: 'S',
        planDesc: '',
        srchType: false
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      isSrchByS: false,
      helplist: false,
      polTypeHelpList: false,
      schemeHelpList: false,
      busClsHelpList: false,
      polNoList: []
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getPropPlan
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.propType = data.propPlan.propType
            this.form.polType = data.propPlan.polType
            this.form.scheme = data.propPlan.scheme
            this.form.planNo = data.propPlan.planNo
            this.form.planDesc = data.propPlan.planDesc
            this.form.srchBy = data.propPlan.srchBy
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'propPlan' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPropPlan
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updatePropPlan
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldName) {
      this.resetMessages()
      this.helplist = true
      if (fieldName === 'polType') {
        this.polTypeHelpList = true
        this.schemeHelpList = false
        this.busClsHelpList = false
      } else {
        if (this.form.srchBy === 'S') {
          this.polTypeHelpList = false
          this.schemeHelpList = true
          this.busClsHelpList = false
        } else {
          this.polTypeHelpList = false
          this.schemeHelpList = false
          this.busClsHelpList = true
        }
      }
    },
    async getPolNoList() {
      const apiURI = this.menu.getPkgPlanList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiURI))
          const { data } = result.data
          this.polNoList = []
          if (data) {
            data.pkgPlanList.map((datamap) => {
              const convertList = {
                code: datamap.value,
                value: datamap.label
              }
              this.polNoList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doAssignPolType(data) {
      this.form.polType = data.polType
    },
    doAssignScheme(data) {
      this.form.scheme = data.scheme
    },
    doAssignBusCls(data) {
      this.form.scheme = data.busCls
    },
    doClose() {
      this.helplist = false
      this.polTypeHelpList = false
      this.schemeHelpList = false
      this.busClsHelpList = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.propPlanParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    propTypeList() {
      let result = []
      Object.keys(propType).forEach(function (key) {
        const label = propType[key]
        result.push({
          value: label,
          code: key
        })
      })
      return result
    },
    srchByList() {
      let result = []
      Object.keys(srchBy).forEach(function (key) {
        const label = srchBy[key]
        result.push({
          value: label,
          code: key
        })
      })
      return result
    }
  },
  mounted() {
    this.getPolNoList()
  },
  created() {
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  watch: {
    'form.srchBy': function (value) {
      if (value === 'S') {
        this.isSrchByS = false
        this.form.srchType = false
      } else {
        this.isSrchByS = true
        this.form.srchType = true
        this.form.planNo = 'NA'
      }
    }
  },
  mixins: [MessageMixin],
  components: {
    PolTypeHelpList,
    SchemeHelpList,
    BusClsHelpList
  }
}
</script>
